// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__yXq4A","activityContainer":"styles_activityContainer__4caNz","activityDivider":"styles_activityDivider__Lc5cO"};